import * as am4core from '@amcharts/amcharts4/core';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import am4themes_material from '@amcharts/amcharts4/themes/material';
import React, {  useEffect, useRef, useState } from 'react';
import LoadingBar from 'react-top-loading-bar';

import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';

import GridContainer from 'src/components/Grid/GridContainer.js';
import GridItem from 'src/components/Grid/GridItem';
import useCustomerAccountFeatures from 'src/hooks/useCustomerAccountFeatures.js';
import apiService from 'src/services/api.service';
import PDFModule from 'src/services/pdf.service';
import { darkTheme } from 'src/themes/darkTheme';
import { lightThemeAdmin } from 'src/themes/lightTheme';

import ApplicationMenus from '../layouts/ApplicationMenus';
import TopRedBar from '../layouts/TopRedBar';
import FeatureDisabledMessage from '../parts/FeatureDisabledMessage';
import TrendsFilters from './Trends/FilterControls/TrendsFilters';
import TabsContainer from './Trends/TabsContainer';

am4core.useTheme(am4themes_material);
am4core.addLicense('255064348');
am4core.useTheme(am4themes_animated);

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflowY: 'auto',
    backgroundColor: (props) => props.adminTheme.palette.trendsOverTime.mainBackgroundColor,
  },
  container: {
    paddingBottom: theme.spacing(4),
    maxWidth: '1600px',
  },
  pdfButton: {
    marginTop: '10px',
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
  },
}));

function Trends(props) {
  let theme = parseInt(localStorage.getItem('theme')) === 1 ? lightThemeAdmin : darkTheme;
  const themeProps = { adminTheme: theme };
  const classes = useStyles(themeProps);
  const progressRef = useRef(null);
  const [filterComponentData, setFilterComponentData] = useState(true);
  const [openBackdrop, setOpenBackdrop] = React.useState(false);
  const [baseQueryString, setBaseQueryString] = React.useState();
  const [accountId, setAccountId] = useState();
  const [trendOverTimeSettings, setTrendOverTimeSettings] = useState();
  const { enabledTrendsOverTime } = useCustomerAccountFeatures();

  const generatePdf = () => {
    setOpenBackdrop(true);
    am4core.unuseTheme(am4themes_animated);
    const element = document.querySelector('#dashboardPrint');
    const options = {
      filename: 'Trends-' + new Date().toDateString() + '.pdf',
      excludeClassNames: ['exclude'],
      company: filterComponentData.companyName,
      period: filterComponentData.periodName,
      suppliers: filterComponentData.suppliers ? filterComponentData.supplierName : 'ALL',
    };

    return PDFModule(element, options, () => {
      am4core.useTheme(am4themes_animated);
      setOpenBackdrop(false);
    });
  };

  useEffect(() => {
    if (filterComponentData && filterComponentData.accountId) {
      setAccountId(filterComponentData.accountId);
    }
  }, [filterComponentData]);

  useEffect(() => {
    const loadSettings = async () => {
      let result = await apiService.getTrendOverTimeSettings(accountId);
      setTrendOverTimeSettings(result.data);
    };

    setTrendOverTimeSettings(undefined);
    if (accountId) {
      loadSettings();
    }
  }, [accountId]);

  return (
    <>
      <ThemeProvider theme={theme}>
        <Backdrop className={classes.backdrop} open={openBackdrop}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <CssBaseline />
        <div className={classes.root}>
          <LoadingBar color={theme.loadingBar.color} ref={progressRef} height="4px" />
          <ApplicationMenus />
          <main className={classes.content}>
            <TopRedBar />
            <Container id="dashboardPrint" maxWidth="lg" className={classes.container}>
              {enabledTrendsOverTime ? (
                <>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      <TrendsFilters sendFilterComponentData={setFilterComponentData} sendQueryStrings={setBaseQueryString} onClickGeneratePdf={generatePdf} />
                    </GridItem>
                  </GridContainer>
                  <TabsContainer
                    filterComponentData={filterComponentData}
                    baseQueryString={baseQueryString}
                    trendOverTimeSettings={trendOverTimeSettings}
                  ></TabsContainer>
                </>
              ) : (
                <FeatureDisabledMessage />
              )}
            </Container>
          </main>
        </div>
      </ThemeProvider>
    </>
  );
}

export default Trends;
